import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CreditCard, Merchant, PaymentType } from '../merchant-details.model';
import { MerchantDetailsState } from '../merchant-details.state';

/**
 * Selects the entire merchant state
 * @returns The merchant state
 */
export const selectMerchant = createFeatureSelector<MerchantDetailsState>('merchant');

/**
 * Selects the order merchant state
 */
export const selectOrderMerchantDetails = createSelector(selectMerchant, (merchant) => merchant.orderMerchant);

/**
 * Selects the Order Merchant Is Trades Merchant state
 */
export const selectOrderMerchantIsTradesMerchant = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): boolean => state?.isTradeMerchant ?? null
);

/**
 * Selects the order merchant payment types
 */
export const selectOrderMerchantPaymentTypes = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): PaymentType[] => state?.paymentTypes
);

/**
 * Returns credit cards for the order merchant
 */
export const selectOrderMerchantCreditCards = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): CreditCard[] => state?.creditCards
);

/**
 * Find out if order merchant has apple pay configured
 */
export const selectOrderMerchantApplePayCards = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): CreditCard[] => state?.applePayCards
);

/**
 * Find out if order merchant has google pay configured
 */
export const selectOrderMerchantGooglePayCards = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): CreditCard[] => state?.googlePayCards
);

export const selectOrderMerchantId = createSelector(
	selectOrderMerchantDetails,
	(state: Merchant): string => state?.merchantId ?? null
);
